// React builder
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography, Container } from "@mui/material";

// Styles
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import LodingComponent from "./loding";

// App Icons
// App Icons
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import InventoryIcon from '@mui/icons-material/Inventory';
import TripOriginIcon from '@mui/icons-material/TripOrigin';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import ViewDayIcon from '@mui/icons-material/ViewDay';
import TextureIcon from '@mui/icons-material/Texture';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import ChatIcon from '@mui/icons-material/Chat';
import PersonIcon from '@mui/icons-material/Person';
import ListAltIcon from '@mui/icons-material/ListAlt';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import ToysIcon from '@material-ui/icons/Toys';
import TimelineIcon from '@material-ui/icons/Timeline';
import TimelineOutlinedIcon from '@material-ui/icons/TimelineOutlined';
import AccountBalanceRoundedIcon from '@material-ui/icons/AccountBalanceRounded';
import ViewHeadlineRoundedIcon from '@material-ui/icons/ViewHeadlineRounded';
import CategoryIcon from '@mui/icons-material/Category';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PostAddIcon from '@mui/icons-material/PostAdd';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SummarizeIcon from '@mui/icons-material/Summarize';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';

//Auth
import { AuthProvider, useAuth } from "./AuthContext";

//Logout
import Logout from "./Logout";

//SessionTimeOut
//import SessionTimeout from "./SessionTimeout";

// Home
import Home from "./components/pages/Home";
//Customer
import CustomerIndex from "./components/pages/Customer";
import CustomerEdit from "./components/pages/Customer/Edit";
import { CustomerCreate } from "./components/pages/Customer/Create";
// User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";
//Supplier
import SupplierIndex from "./components/pages/Supplier";
import SupplierEdit from "./components/pages/Supplier/Edit";
import { SupplierCreate } from "./components/pages/Supplier/Create";

//Item 
import ItemCreate from "./components/pages/Item/Create";
import ItemEdit from "./components/pages/Item/Edit";
import ItemIndex from "./components/pages/Item/Index";
//Bank 

import BankIndex from "./components/pages/Bank/Index";
import BankCreate from "./components/pages/Bank/Create";
import BankEdit from "./components/pages/Bank/Edit";
//Account Head
import AccountHeadIndex from "./components/pages/AccountHead/Index";
import AccountHeadCreate from "./components/pages/AccountHead/Create";
import AccountHeadEdit from "./components/pages/AccountHead/Edit";

//Income Or Expense
import IncomeExpenseIndex from "./components/pages/IncomeExpense/Index";
import IncomeExpenseCreate from "./components/pages/IncomeExpense/Create";
import IncomeExpenseEdit from "./components/pages/IncomeExpense/Edit";
import IncomeExpenseDetails from "./components/pages/IncomeExpense/Details";
//Purchase
import PurchaseIndex from "./components/pages/purchase/Index";
import PurchaseCreate from "./components/pages/purchase/Create";
import PurchaseEdit from "./components/pages/purchase/Edit";
import PurchaseDetails from "./components/pages/purchase/Details";
// Payment
import PaymentIndex from "./components/pages/Payment/Index";
import PaymentCreate from "./components/pages/Payment/Create";
import PaymentDetails from "./components/pages/Payment/Details";
import PaymentEdit from "./components/pages/Payment/Edit";
// Receipt
import ReceiptIndex from "./components/pages/Receipt/Index";
import ReceiptCreate from "./components/pages/Receipt/Create";
import ReceiptDetails from "./components/pages/Receipt/Details";
import ReceiptEdit from "./components/pages/Receipt/Edit";
//JournalEntry
import JournelEntry from "./components/pages/JournalEntryPage/Create";
import JournelEntryIndex from "./components/pages/JournalEntryPage/Index";
import JournalEntryEdit from "./components/pages/JournalEntryPage/Edit";
import JournalEntryDetails from "./components/pages/JournalEntryPage/Details";
//Reports
import CreditorDebitorReport from "./components/pages/Report/CreditorDebitor";
import SupplierOutstandingReport from "./components/pages/Report/SupplierOutstanding";
import ItemWisePurchaseReport from "./components/pages/Report/ItemWisePurchaseSummary";
import MonthlyWisePurchaseReport from "./components/pages/Report/MonthlyWisePurchase";
import CustomerWiseExpenseReport from "./components/pages/Report/CustomerWiseExpense";
import Ledger from "./components/pages/Report/Ledger";

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [otherOpen, setOtherOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };

  const handleOtherClick = () => {
    setOtherOpen(!otherOpen);
  };


  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };

  const handleItemClick = () => {
    setItemOpen(!itemOpen);
  };

  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName, username } = useAuth();

  const [fontSize, setFontSize] = useState(window.innerWidth < 768 ? '12px' : '16px');

  useEffect(() => {
    const handleResize = () => {
      setFontSize(window.innerWidth < 768 ? '12px' : '16px');
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Router>
      <AuthProvider>
        {/* <SessionTimeout /> */}

        <AppBar position="static" style={{ backgroundColor: '#6A9C89', height: '55px' }}>
          <Toolbar style={{ minHeight: '55px', padding: '0 24px' }}>

            {/* Left Side - Menu Icon */}
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>

            {/* Center - Logo & Title */}
            <Link
              to="/Home"
              style={{
                textDecoration: 'none',
                color: 'inherit',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <FiHome style={{ marginRight: '8px' }} />
              <Typography
                variant="h6"
                style={{
                  fontWeight: 'bolder',
                  fontSize: fontSize,
                  textTransform: 'uppercase',
                }}
              >
                {companyName}
              </Typography>
            </Link>

            {/* Right Side - Push items to the right */}
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', gap: '10px' }}>

              <div className="white-icon" style={{ marginTop: '5px', marginLeft: '10px' }}>
                <Logout />
              </div>
            </div>


          </Toolbar>
        </AppBar>

        <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}
        // PaperProps={{
        //   style: { backgroundColor: '#27391C' }
        // }}
        >
          <div style={{ fontWeight: 'bold', marginTop: '10px' }}>

            <Typography
              variant="h6"
              className="dual-text"
              style={{
                fontWeight: 'bolder',
                fontSize: fontSize,
                marginLeft: '15px',
                color: 'black',
              }}
            >
              OEN
            </Typography>

          </div>
          <List>

            <ListItem button onClick={handleMasterClick}>
              <ListItemText primary="MASTER" />
              {masterOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={masterOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>
                <ListItem button component={NavLink} to="/CustomerIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PersonIcon style={{ color: 'darkblue', fontWeight: 'bolder' }} />  <ListItemText primary="Customer" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/SupplierIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <HowToRegIcon style={{ color: 'brown', fontWeight: 'bolder' }} />  <ListItemText primary="Supplier" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/ItemIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ListAltIcon style={{ color: ' #3C3D37', height: '20px' }} /><ListItemText primary="Item" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/BankIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AccountBalanceRoundedIcon style={{ color: '#006A71', height: '20px' }} /><ListItemText primary="Bank" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/AccountHeadIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ViewHeadlineRoundedIcon style={{ color: ' #3E3F5B', height: '20px' }} /><ListItemText primary="Account Head" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
              </List>
            </Collapse>

            <ListItem button onClick={handleItemClick}>
              <ListItemText primary="TRANSACTION" />
              {itemOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={itemOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/PurchaseIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <InventoryIcon style={{ color: 'green', height: '20px' }} /><ListItemText primary="Purchase" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>


              </List>
            </Collapse>

            <ListItem button onClick={handleOtherClick}>
              <ListItemText primary="ACCOUNTS" />
              {otherOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={otherOpen} timeout="auto" unmountOnExit>

              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/JournelEntryIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PostAddIcon style={{ color: 'darkblue', height: '20px' }} /><ListItemText primary="Journel Entry " style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/IncomeExpenseIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <TimelineOutlinedIcon style={{ color: 'red', height: '20px' }} /><ListItemText primary="Income / Expense" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PaymentIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PaymentIcon style={{ color: '#C40C0C', height: '20px' }} /><ListItemText primary="Payment" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ReceiptIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ReceiptLongIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="Receipt" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

              </List>

            </Collapse>

            <ListItem button onClick={handleReportClick}>
              <ListItemText primary="REPORT" />
              {reportOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={reportOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/Ledger" activeClassName="selected" onClick={handleDrawerClose}>
                  <SummarizeIcon style={{ color: 'darkmagenta', height: '20px' }} /><ListItemText primary="Ledger" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/CreditorDebitorReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <SummarizeIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Creditors/Debitors" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SupplierOutstandingReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <SupervisedUserCircleIcon style={{ color: 'black', height: '20px' }} /><ListItemText primary="Supplier Outstanding" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ItemWisePurchaseReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <DragIndicatorIcon style={{ color: '#644A07', height: '20px' }} /><ListItemText primary="Item Wise Purchase" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/MonthlyWisePurchaseReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <CalendarMonthIcon style={{ color: '#4A102A', height: '20px' }} /><ListItemText primary="Montly Purchase" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/CustomerWiseExpenseReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <SpeakerNotesIcon style={{ color: 'darkblue', height: '20px' }} /><ListItemText primary="Customer Expense" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

              </List>
            </Collapse>
            <ListItem button onClick={handleUserClick}>
              <ListItemText primary="USER"  />
              {userOpen ? <ExpandLess /> : <ExpandMore  />}
            </ListItem>

            <Collapse in={userOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px'}}>
                {roleName == "SuperAdmin" && (
                  <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" onClick={handleDrawerClose}
                    // sx={{
                    //   '&:hover': { backgroundColor: '#FFFFEC' }
                    // }}
                  >
                    <PeopleAltIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="User" style={{ marginLeft: '3px', color: 'black' }} />
                  </ListItem>
                )}

                {roleName == "SuperAdmin" && (
                  <ListItem button component={NavLink} to="/RoleIndex" activeClassName="selected" onClick={handleDrawerClose}
                    // sx={{
                    //   '&:hover': { backgroundColor: '#FFFFEC' }
                    // }}
                  >
                    <AccessibilityIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Role" style={{ marginLeft: '3px', color: 'black' }} />
                  </ListItem>
                )}

                <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose}
                  // sx={{
                  //   '&:hover': { backgroundColor: '#FFFFEC' }
                  // }}
                >
                  <SecurityIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Change Password" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
              </List>
            </Collapse>
          </List>
        </Drawer>


        <Container maxWidth="xl">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/Home" exact component={Home} />
            {/* Bank */}
            <Route path="/BankIndex" component={BankIndex} />
            <Route path="/BankCreate" component={BankCreate} />
            <Route path="/BankEdit/:id" component={BankEdit} />
            {/* Customer */}
            <Route path="/CustomerIndex" component={CustomerIndex} />
            <Route path="/CustomerCreate" component={CustomerCreate} />
            <Route path="/CustomerEdit/:id" component={CustomerEdit} />
            {/* Supplier */}
            <Route path="/SupplierIndex" component={SupplierIndex} />
            <Route path="/SupplierCreate" component={SupplierCreate} />
            <Route path="/SupplierEdit/:id" component={SupplierEdit} />

            {/* User */}
            <Route path="/UserIndex" component={UserIndex} />
            <Route path="/UserCreate" component={UserCreate} />
            <Route path="/UserEdit/:id" component={UserEdit} />
            <Route path="/UserDetail/:id" component={UserDetail} />
            <Route path="/PasswordChange" component={PasswordChange} />

            {/* Item */}
            <Route path="/ItemIndex" component={ItemIndex} />
            <Route path="/ItemCreate" component={ItemCreate} />
            <Route path="/ItemEdit/:id" component={ItemEdit} />
            {/* Income Expense */}
            <Route path="/IncomeExpenseIndex" component={IncomeExpenseIndex} />
            <Route path="/IncomeExpenseCreate" component={IncomeExpenseCreate} />
            <Route path="/IncomeExpenseEdit/:id" component={IncomeExpenseEdit} />
            <Route path="/IncomeExpenseDetails/:id" component={IncomeExpenseDetails} />
            {/* Account Head */}
            <Route path="/AccountHeadIndex" component={AccountHeadIndex} />
            <Route path="/AccountHeadCreate" component={AccountHeadCreate} />
            <Route path="/AccountHeadEdit/:id" component={AccountHeadEdit} />
            {/* Purchase */}
            <Route path="/PurchaseIndex" component={PurchaseIndex} />
            <Route path="/PurchaseCreate" component={PurchaseCreate} />
            <Route path="/PurchaseEdit/:id" component={PurchaseEdit} />
            <Route path="/PurchaseDetails/:id" component={PurchaseDetails} />
            {/* JournalEntry */}
            <Route path="/JournelEntry" component={JournelEntry} />
            <Route path="/JournelEntryIndex" component={JournelEntryIndex} />
            <Route path="/JournalEntryEdit/:id" component={JournalEntryEdit} />
            <Route path="/JournalEntryDetails/:id" component={JournalEntryDetails} />
            {/* Payment */}
            <Route path="/PaymentIndex" component={PaymentIndex} />
            <Route path="/PaymentCreate" component={PaymentCreate} />
            <Route path="/PaymentDetails/:id" component={PaymentDetails} />
            <Route path="/PaymentEdit/:id" component={PaymentEdit} />
            {/* Receipt */}
            <Route path="/ReceiptIndex" component={ReceiptIndex} />
            <Route path="/ReceiptCreate" component={ReceiptCreate} />
            <Route path="/ReceiptDetails/:id" component={ReceiptDetails} />
            <Route path="/ReceiptEdit/:id" component={ReceiptEdit} />
            {/* Report */}
            <Route path="/CreditorDebitorReport" component={CreditorDebitorReport} />
            <Route path="/SupplierOutstandingReport" component={SupplierOutstandingReport} />
            <Route path="/ItemWisePurchaseReport" component={ItemWisePurchaseReport} />
            <Route path="/MonthlyWisePurchaseReport" component={MonthlyWisePurchaseReport} />
            <Route path="/CustomerWiseExpenseReport" component={CustomerWiseExpenseReport} />
            <Route path="/Ledger" component={Ledger} />
            
          </Switch>
        </Container>

      </AuthProvider>
    </Router>
  );
};

export default App;

